const Designer = () => import(/* webpackChunkName: "designer" */ './Designer');

export default [{
  path: '/designer',
  component: Designer,
  name: 'designer',
}, {
  path: '/designer/:campaignId',
  component: Designer,
  name: 'designerDraft',
  props: true,
}];